import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Threefiveseaterbusonrentinpune() {



  const cardData = {
"keyword": "35 Seater Bus on Rent in Pune",

"headingDescription":
  "Aaradhya Travels offers reliable 35 Seater Bus on Rent in Pune for large group travel including family functions, corporate tours, weddings, school trips, pilgrimage journeys, and outstation trips. Our spacious AC buses with pushback seats and experienced drivers ensure safe, comfortable, and affordable transportation across Pune and Maharashtra for all group travel needs.",

"topPlaces": [
{
"title": "Amboli",
"description":
"Amboli is a scenic hill station in the Sahyadri range known for waterfalls, misty valleys, and monsoon beauty. It is widely chosen for long group trips and nature tours from Pune using 32 seater buses."
},
{
"title": "Chiplun",
"description":
"Chiplun is a scenic Konkan town surrounded by rivers, greenery, and ghats. It is a popular stop for long-distance group travel and leisure tours from Pune."
},
  {
"title": "Shani Shingnapur",
"description":
"Shani Shingnapur is a famous pilgrimage village known for the Shani Temple where Lord Shani is worshipped. It is a highly visited spiritual destination from Pune, often preferred by group travelers using 32 seater buses for comfortable temple darshan and religious tours."
},
{
"title": "Bhandardara",
"description":
"Bhandardara is a beautiful hill station known for Arthur Lake, Randha Falls, and lush green valleys. It is a peaceful weekend getaway from Pune, popular for group tours and nature trips using 32 seater buses."
},
{
"title": "Kaas Plateau",
"description":
"Kaas Plateau, also called the Valley of Flowers of Maharashtra, is a UNESCO World Heritage site famous for seasonal wildflowers and biodiversity. It is a popular monsoon tourism destination for group travel from Pune."
},
{
"title": "Dapoli",
"description":
"Dapoli is a peaceful coastal destination known for clean beaches, dolphin spotting, and calm surroundings. It is ideal for family and group tours from Pune using 32 seater buses."
},
{
"title": "Murud-Janjira",
"description":
"Murud-Janjira is famous for its sea fort located on an island, attracting history lovers and tourists. It is a popular coastal sightseeing destination for group tours from Pune."
},
{
"title": "Tamhini Ghat",
"description":
"Tamhini Ghat is a scenic monsoon destination known for waterfalls, foggy mountains, and lush greenery. It is one of the most popular short road trips from Pune for group travel."
},
{
"title": "Pawna Lake",
"description":
"Pawna Lake is a popular camping and weekend getaway spot near Lonavala known for lakeside tents, bonfires, and sunset views. It is widely chosen for group camping trips from Pune."
},
{
"title": "Ratnagiri",
"description":
"Ratnagiri is a coastal Konkan destination known for beaches, forts, Alphonso mangoes, and long scenic road trips. It is a popular long-distance group travel destination from Pune."
}
],



services: [
  {
    name: "35 Seater Bus on Rent in Pune",
    description: "35 seater bus on rent in Pune service provides spacious and comfortable transportation for family tours, school trips, airport transfers, corporate outings, wedding travel, and outstation journeys. Well-maintained buses ensure smooth highway travel suitable for medium and large group transportation requirements. Professional chauffeurs ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient 35 seater bus reservations."
  },
  {
    name: "35 Seater Bus on Rent for Pune to Outstation",
    description: "35 seater bus on rent for Pune to outstation service offers dependable long-distance transportation for Goa tours, Mahabaleshwar trips, Konkan travel, pilgrimage journeys, and family vacations. Spacious seating and luggage space ensure comfortable highway journeys suitable for tourist and corporate groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient outstation bus reservations."
  },
  {
    name: "35 Seater Bus on Rent for Corporate Office",
    description: "35 seater bus on rent for corporate office service provides professional transportation for employee travel, industrial visits, conferences, business meetings, office outings, and corporate tours. Spacious buses ensure comfortable travel experiences suitable for executive teams and office staff. Professional drivers ensure punctual pickup and safe transportation services throughout the route. Pickup services are available from IT parks, offices, hotels, airports, and commercial areas across Pune. Flexible booking options allow convenient corporate bus reservations."
  },
  {
    name: "35 Seater Bus on Rent for Corporate Event",
    description: "35 seater bus on rent for corporate event service offers reliable transportation for business conferences, seminars, office celebrations, team outings, exhibitions, and employee travel requirements. Comfortable seating and spacious interiors ensure smooth travel suitable for corporate passengers and executive groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from offices, IT parks, hotels, airports, and commercial locations across Pune. Flexible booking options allow convenient corporate event bus reservations."
  },
  {
    name: "35 Seater Bus Rental Services in Pune",
    description: "35 seater bus rental services in Pune provide comfortable transportation for weddings, educational tours, tourist travel, airport transfers, office outings, and family functions. Spacious seating and smooth highway performance ensure pleasant travel experiences suitable for all passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient bus rental reservations."
  },
  {
    name: "35 Seater Bus on Rent AC Bus",
    description: "35 seater bus on rent AC bus service provides premium air-conditioned transportation for business travel, sightseeing tours, weddings, family vacations, and long-distance journeys. Comfortable seating and cooling systems ensure pleasant travel experiences suitable for all weather conditions. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient AC bus reservations."
  },
  {
    name: "35 Seater Bus on Rent Non AC Bus",
    description: "35 seater bus on rent non AC bus service offers economical transportation for school trips, local sightseeing, educational tours, office outings, and budget-friendly group travel requirements. Spacious interiors ensure comfortable seating suitable for large passenger groups and short-distance journeys. Professional drivers ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, schools, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient non AC bus reservations."
  },
  {
    name: "35 Seater Bus on Rent for Marriage Function",
    description: "35 seater bus on rent for marriage function service provides luxurious transportation for wedding guests, family members, bridal parties, and event travel requirements. Spacious seating and elegant interiors ensure smooth travel suitable for wedding ceremonies and celebrations. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the wedding schedule. Pickup services are available from homes, banquet halls, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient marriage bus reservations."
  },
  {
    name: "35 Seater Bus on Rent for School Picnic",
    description: "35 seater bus on rent for school picnic service offers safe and comfortable transportation for educational tours, school outings, student travel, and one-day picnic trips. Spacious seating and smooth highway performance ensure pleasant journeys suitable for students, teachers, and educational groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from schools, colleges, coaching institutes, homes, and educational campuses across Pune. Flexible booking options allow convenient school picnic bus reservations."
  },
  {
    name: "35 Seater Bus on Rent Corporate Picnic",
    description: "35 seater bus on rent corporate picnic service provides dependable transportation for office outings, employee recreational trips, team-building activities, and corporate group travel. Comfortable seating and spacious interiors ensure smooth travel experiences suitable for business teams and company staff. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from IT parks, offices, hotels, and commercial areas across Pune. Flexible booking options allow convenient corporate picnic bus reservations."
  },
  {
    name: "35 Seater Bus on Rent Pimpri Chinchwad",
    description: "35 seater bus on rent Pimpri Chinchwad service offers reliable transportation for airport transfers, family tours, educational trips, office outings, and outstation journeys from Pimpri Chinchwad Pune. Spacious buses ensure comfortable seating and smooth travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and commercial locations across Pimpri Chinchwad Pune. Flexible booking options allow convenient bus reservations."
  },
  {
    name: "Bharat Benz 35 Seater Bus on Rent",
    description: "Bharat Benz 35 seater bus on rent service provides premium and spacious transportation for luxury travel, corporate tours, weddings, educational trips, and outstation journeys. Comfortable seating and modern bus features ensure smooth highway travel suitable for executive and tourist travel requirements. Professional drivers ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Bharat Benz bus reservations."
  },
  {
    name: "Pune to Shirdi 35 Seater Bus on Rent",
    description: "Pune to Shirdi 35 seater bus on rent service offers comfortable transportation for Sai Baba darshan tours, pilgrimage journeys, family trips, and spiritual group travel from Pune. Spacious buses ensure smooth highway travel suitable for devotees, tourist groups, and senior citizens. Professional chauffeurs ensure safe driving and dependable transportation services throughout the Shirdi route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Shirdi bus reservations."
  },
  {
    name: "Pune to Konkan Darshan 35 Seater Bus on Rent",
    description: "Pune to Konkan Darshan 35 seater bus on rent service provides premium transportation for beach tourism, temple visits, sightseeing tours, family vacations, and group travel across Konkan destinations. Spacious seating and luggage space ensure comfortable highway journeys suitable for tourist and pilgrimage groups. Professional drivers ensure safe driving and reliable transportation services throughout the Konkan route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Konkan bus reservations."
  },
  {
    name: "35 Seater Bus on Rent for 5 Jyotirlinga from Pune",
    description: "35 seater bus on rent for 5 Jyotirlinga from Pune service offers dependable transportation for devotees visiting sacred Jyotirlinga temples across Maharashtra and nearby regions. Spacious buses ensure comfortable seating and smooth highway travel suitable for spiritual groups and pilgrimage journeys. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Jyotirlinga bus reservations."
  },
  {
    name: "Pune to Nashik Bus on Rent for Picnic",
    description: "Pune to Nashik bus on rent for picnic service provides comfortable transportation for family outings, educational tours, office trips, sightseeing travel, and picnic journeys from Pune. Spacious seating and smooth highway performance ensure pleasant travel experiences suitable for all passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, schools, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Nashik picnic bus reservations."
  },
  {
    name: "35 Seater Bus Hire for School Picnic",
    description: "35 seater bus hire for school picnic service offers safe and spacious transportation for educational tours, student outings, school trips, and group travel requirements. Comfortable seating and luggage capacity ensure smooth travel experiences suitable for students, teachers, and educational groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from schools, colleges, coaching institutes, homes, and educational campuses across Pune. Flexible booking options allow convenient school picnic bus reservations."
  }
],

tableData: [
  ["35 Seater Bus on Rent in Pune", "35 Seater Bus on Rent for Pune to Outstation"],
  ["35 Seater Bus on Rent for Corporate Office", "35 Seater Bus on Rent for Corporate Event"],
  ["35 Seater Bus Rental Services in Pune", "35 Seater Bus on Rent AC Bus"],
  ["35 Seater Bus on Rent Non AC Bus", "35 Seater Bus on Rent for Marriage Function"],
  ["35 Seater Bus on Rent for School Picnic", "35 Seater Bus on Rent Corporate Picnic"],
  ["35 Seater Bus on Rent Pimpri Chinchwad", "Bharat Benz 35 Seater Bus on Rent"],
  ["Pune to Shirdi 35 Seater Bus on Rent", "Pune to Konkan Darshan 35 Seater Bus on Rent"],
  ["35 Seater Bus on Rent for 5 Jyotirlinga from Pune", "Pune to Nashik Bus on Rent for Picnic"],
  ["35 Seater Bus Hire for School Picnic", "35 Seater Bus on Rent in Pune"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable 35 Seater Bus on Rent in Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable 35 seater bus rental service in Pune with comfortable vehicles, professional drivers, and smooth travel arrangements for corporate events, school trips, weddings, and large group tours."
      },
      {
        WhyChooseheading: "Affordable 35 Seater Bus Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable 35 seater bus on rent in Pune with transparent pricing, flexible booking plans, and complete travel assistance without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Bus Booking Service in Pune",
        WhyChoosedescription: "Our 35 seater bus rental service in Pune operates 24 hours for airport transfers, employee transportation, educational tours, pilgrimage journeys, family functions, and outstation travel."
      },
      {
        WhyChooseheading: "Comfortable & Fully AC 35 Seater Buses",
        WhyChoosedescription: "All 35 seater buses provided by Aaradhya Travels are spacious, air-conditioned, clean, and regularly maintained for safe and comfortable group travel experiences."
      },
      {
        WhyChooseheading: "Customized One Day & Multi-Day Tours",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day tours, weekend trips, multi-day outstation journeys, and flexible travel packages according to customer travel requirements."
      },
      {
        WhyChooseheading: "Ideal for Corporate & Large Group Travel",
        WhyChoosedescription: "The 35 seater bus is ideal for corporate teams, school and college groups, wedding guest transportation, tourist groups, and family vacations from Pune."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides doorstep pickup from Pune Airport, railway stations, hotels, homes, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Long Distance Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local and outstation group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is 35 seater bus on rent in Pune?", answer: "35 seater bus rental service in Pune provides comfortable group transportation for corporate travel, school trips, weddings, family tours, and outstation journeys." },
    { question: "Is 35 seater bus booking available 24 hours?", answer: "Yes, Aaradhya Travels provides 24/7 35 seater bus rental service in Pune." },
    { question: "Can I book 35 seater bus for outstation travel?", answer: "Yes, customers can book 35 seater buses for outstation tours, pilgrimage journeys, holiday travel, and hill station trips." },
    { question: "Do you provide 35 seater buses for corporate events?", answer: "Yes, Aaradhya Travels provides 35 seater bus rental service for corporate meetings, office outings, conferences, and employee transportation." },
    { question: "Are all 35 seater buses air-conditioned?", answer: "Yes, all 35 seater buses are fully air-conditioned and maintained for comfortable group travel." },
    { question: "Can I book 35 seater bus online in Pune?", answer: "Yes, customers can easily book 35 seater bus rental service online or through phone booking." },
    { question: "Do you provide buses for weddings and educational tours?", answer: "Yes, Aaradhya Travels provides spacious 35 seater buses suitable for weddings, school trips, college tours, and family travel." },
    { question: "Are 35 seater bus rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for 35 seater bus rental?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." },
    { question: "Do you provide pickup from Pune Airport and railway stations?", answer: "Yes, Aaradhya Travels provides pickup and drop services from Pune Airport, railway stations, hotels, and all major Pune locations." }
  ];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ajinkya Bendre",
    feedback:
      "For our school excursion, a 35 Seater Bus on rent in Pune proved to be the ideal travel solution. The bus was comfortable, well-maintained, and accommodated everyone without any inconvenience.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Meenal Kshirsagar",
    feedback:
      "We booked transportation for a social gathering and selected a 35 Seater Bus rental in Pune. The journey was pleasant, the seating arrangement was spacious, and the service met all our expectations.",
    rating: 5
  }
];






  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "35 Seater Bus on Rent in Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/35-seater-bus-on-rent-pune.jpg",
  "description": "Book 35 Seater Bus on rent in Pune with Aaradhya Travels for corporate events, weddings, school picnics, airport transfers, family trips, and outstation travel. Affordable AC and Non-AC 35 seater bus available for Pune and Maharashtra tours.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2765"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/35-seater-bus-on-rent-in-pune"
  }
};






  return (
    <div>
<Helmet>
  <title>
    35 Seater Bus on Rent in Pune | AC & Non-AC Bus Hire | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire 35 Seater Bus on rent in Pune with Aaradhya Travels. Affordable AC and Non-AC bus available for corporate office travel, events, weddings, school picnics, airport transfers, and outstation trips."
  />

  <meta
    name="keywords"
    content="35 seater bus on rent in pune, 35 seater bus on rent for pune to outstation, 35 seater bus on rent for corporate office, 35 seater bus on rent for corporate event, 35 Seater Bus Rental Services in Pune, 35 seater bus on rent ac bus, 35 seater bus on rent non ac bus, 35 seater bus on rent for marriage function, 35 seater bus on rent for school picnic"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/13.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Threefiveseaterbusonrentinpune;